import React from 'react';
import { createRoot } from 'react-dom/client';

import DataProvider from '../components/DataProvider';
import PostsList from '../components/Post/PostsList';

export default function posts(selector, api_url, post_type = 'post') {

    if( document.querySelector(selector) == null) return;

    //component can have multiple roots and can be rendered multiple times on a single page
    let nodes = document.querySelectorAll(selector);

    
    nodes.forEach( node => {
        
        const full = node.dataset.full != undefined ? node.dataset.full : false;

        const root = createRoot(node);

        root.render(
            <DataProvider api_url={api_url}>
                <PostsList full={full} post_type={post_type} />
            </DataProvider>
        );  

    });

}